import { observer } from "mobx-react-lite";
import { ReactNode } from "react";

import Banner from "../ui/banner";
import { Button } from "../ui/button";

interface FormatWarningBannerProps {
  setIsConfirmModalOpen: (isOpen: boolean) => void;
  description?: ReactNode;
}

const FormatWarningBanner: React.FC<FormatWarningBannerProps> = ({
  setIsConfirmModalOpen,
  description = (
    <>
      <span>
        To use dynamic variables inside your schema, please switch your prompt template from{" "}
      </span>
      <code className="whitespace-nowrap rounded bg-gray-100 px-1.5 py-0.5 font-mono text-sm dark:bg-gray-800">
        f-string
      </code>
      <span> to </span>
      <code className="whitespace-nowrap rounded bg-gray-100 px-1.5 py-0.5 font-mono text-sm dark:bg-gray-800">
        jinja2
      </code>
      <span>. </span>
    </>
  ),
}) => {
  const onFormatChange = () => {
    setIsConfirmModalOpen(true);
  };

  return (
    <Banner
      className="w-full"
      suffix={
        <Button onClick={onFormatChange} variant="link" className="ml-auto whitespace-nowrap">
          Click to change
        </Button>
      }
    >
      {description}
    </Banner>
  );
};

export default observer(FormatWarningBanner);
